import React, { useState } from "react";
import { Select, Spin } from "antd";

const { Option } = Select;

const LoadMoreSelect = (props) => {
  const {
    data,
    optionData,
    onChange,
    onSelect,
    setEvent,
    placeHolder,
    scrollProduct,
    setScrollProduct,
    handleSearchitem,
    value,
    disabled
  } = props; // Initial data
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Assume there's more data initially

  const handlePopupScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    
    if (Math.abs(scrollHeight - scrollTop - clientHeight) < 1&& hasMore && !loading) {
      // Trigger load more when scrolled to the bottom
      const temp = scrollProduct;
      setLoading(true);
      setTimeout(() => {
        setScrollProduct((prev) => prev + 10);
        console.log("SSSSS", scrollTop, "H:", scrollHeight, "C:", clientHeight);

        if (temp + 10 > scrollProduct) {
          setHasMore(false); // Stop loading if no more data
        }
        setLoading(false);
      }, 1000); // Simulate an API call
    }
  };

  return (
    <Select
    disabled={disabled}
      className="w-100"
      showSearch
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onSearch={handleSearchitem}
      placeholder={placeHolder}
      onPopupScroll={handlePopupScroll}
      onChange={onChange}
      onSelect={onSelect}
      value={value}
      dropdownRender={(menu) => (
        <>
          {menu}
          {loading && (
            <div style={{ textAlign: "center", padding: 10 }}>
              <Spin size="small" />
            </div>
          )}
        </>
      )}
    >
      {optionData}
      {/* {data.map((item) => (
        <Option lable={item.lable} key={item.value} value={item.value}>
          {item}
        </Option>
      ))} */}
    </Select>
  );
};

export default LoadMoreSelect;
